module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Altri_Pericoli-BN-CL.65c14e8a.svg";